import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IconType } from "antd/es/notification/interface";

export type TAlert = {
  message?: string,
  icon: IconType;
  duration?: number;
}

interface IAlertSlice {
  toasts: TAlert[]
}
const initialState: IAlertSlice = {
  toasts: []
}
export const AlertSlice = createSlice({
  name: "alerts",
  initialState,
  reducers: {
    createAlert: (state, action: PayloadAction<TAlert>) => {
      state.toasts.push(
        action.payload
      );
    },
    shiftAlert: (state) => {
      state.toasts.shift();
    }
  },
});

export const selectorAlert = (state: { notifications: IAlertSlice }) => state.notifications
export const { createAlert, shiftAlert } = AlertSlice.actions;

export default AlertSlice.reducer;
